import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import {
  RouteHandler,
  ShopViewConstants,
  CartStore
} from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import {
  CategoryListStore,
  ShopStore
} from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import dataAids from '../../constants/dataAids';
import * as Metrics from './utils/trackMetric';
import * as MetricEvents from '../../constants/metrics';

class Breadcrumb extends React.Component {
  constructor() {
    super(...arguments);
    this.handleClick = this.handleClick.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.state = this.getStoreState();
  }

  getStoreState() {
    const { taxons, fetching } = CategoryListStore.getState();
    const { sortOption } = ShopStore.getState();

    return {
      fetching,
      taxons,
      sortOption
    };
  }

  componentDidMount() {
    CategoryListStore.addListener('change', this.onStoreChange);
  }

  componentWillUnmount() {
    CategoryListStore.removeListener('change', this.onStoreChange);
  }

  onStoreChange() {
    this.setState(this.getStoreState());
  }

  handleClick(e) {
    e.preventDefault();
    const { cart } = CartStore.getState();
    const beginningCartSize = cart && cart.line_items ? cart.line_items.length : 0;
    const { sortOption } = this.state;
    const data = sortOption ? { sortOption: sortOption } : {};
    Metrics.track(MetricEvents.OLS_CART_CONTINUE_SHOPPING({ beginningCartSize }));
    RouteHandler.navigate(ShopViewConstants.PRODUCT_LISTING, data);
  }

  render() {
    const translate = this.context.translate || (() => {});
    const { currentView, editMode } = this.props;
    if (currentView === ShopViewConstants.PRODUCT_LISTING) {
      return null;
    }

    const { taxons, fetching } = this.state;
    const linkProps = this.context.getLinkProps(ShopViewConstants.PRODUCT_LISTING);
    const isProductView = currentView !== ShopViewConstants.CART;
    const crumbText = !isProductView
      ? translate('products.continue_shopping')
      : translate('products.view_all');
    const isEditProductDetailView = Boolean(
      currentView === ShopViewConstants.PRODUCT_DETAIL && editMode
    );
    const isSearchResultsViewWCats = Boolean(
      currentView === ShopViewConstants.SEARCH_RESULTS && (taxons.length > 0 || fetching)
    );
    const styles = {
      container: {
        textAlign: 'left'
      },
      search: {
        '@sm': {
          display: 'none'
        }
      }
    };

    return (
      <UX2.Element.Block style={ styles.container }>
        <UX2.Element.MoreLink.Backward
          href='javascript:;'
          { ...linkProps }
          onClick={ isEditProductDetailView ? '' : this.handleClick }
          style={ isSearchResultsViewWCats ? styles.search : {} }
        >
          <UX2.Element.Element data-aid={ dataAids.PRODUCTS_VIEW_ALL } children={ crumbText } />
        </UX2.Element.MoreLink.Backward>
      </UX2.Element.Block>
    );
  }
}

Breadcrumb.propTypes = {
  currentView: PropTypes.string,
  editMode: PropTypes.bool
};

Breadcrumb.contextTypes = {
  getLinkProps: PropTypes.func,
  translate: PropTypes.func
};

export default Breadcrumb;
